<template>
  <input-widget :model="model"
                :attribute="attribute"
                type="select2"
                :disabled="disabled"
                :display-field="displayFieldFunction"
                :hint="hint"
                @select2Select="onSelect"
                @select2Unselect="onUnselect"
                :label="label"
                :options="options"
                :multiple="multiple"
                :items="departments.rows"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import {Formatter} from "@/core/services/formatter.service";
  import DepartmentService from "@/modules/setup/department/DepartmentService";

  const {mapState: mapStateDepartment} = createNamespacedHelpers('setup/department');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "DepartmentSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      getDynamicFieldsTemplate: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapStateDepartment(['departments']),
    },
    methods: {
      async onSelect(data) {
        if (this.getDynamicFieldsTemplate) {
          let response = await DepartmentService.getDepartment(data.uuid, {
            expand: 'dynamic_fields_template'
          })
          if (response.success) {
            data['dynamic_fields_template'] = response.body.dynamic_fields_template
          }
        }
        this.$emit('select', data);
      },
      onUnselect(data) {
        this.$emit('unselect', data);
      },
      displayFieldFunction(item) {
        return Formatter.getByMasterLanguage(item.name)
      }
    }
  }
</script>

<style scoped>

</style>
